import { DrawerPropertiesType } from "@website/widget/header/components/drawer/drawer.types";
import { useEffect } from "react";

export const useDrawer = (properties: DrawerPropertiesType) => {
  const { open } = properties;

  useEffect(() => {
    if (open) {
      document.body.classList.add("prevent-scroll");
      return () => document.body.classList.remove("prevent-scroll");
    }
  }, [open]);

  return {
    transitionProperties: {
      in: open,
      timeout: 75
    }
  };
};
